import React from "react";
//#region types
import { DetailsTableProps } from "models/propTypes/listPropTypes";
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
//#endregion
//#region components
import { Grid, Divider } from "@mui/material";
import StyledButton from "./buttons/styledButton";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { UtilsHelper } from "utils/helpers";
import clsx from "clsx";

const DetailsTable: React.FC<DetailsTableProps> = (props) => {
  return (
    <Grid container className={cssExports.detailsTableContainer}>
      {props.title && (
        <Grid container className={cssExports.detailsTableTitle}>
          {props.title}
        </Grid>
      )}
      <table className={clsx(cssExports.detailsTable, props.valueAlignment === "right" && cssExports.detailsTableValueRightAlign)}>
        {props.headers?.length ? (
          <thead>
            <th>{props.headers?.[0]}</th>
            <th>{props.headers?.[1]}</th>
          </thead>
        ) : (
          <></>
        )}
        <tbody>
          {props.detailsList.map((item, index) =>
            item === ACTION_SEPARATOR ? (
              <tr key={index}>
                <td className={cssExports.dividerCell} colSpan={2}>
                  <Divider className={cssExports.dividerGray} />
                </td>
              </tr>
            ) : item !== undefined && item.value ? (
              <tr key={index}>
                {item.key !== undefined && <td className={cssExports.formLabel}>{item.key}</td>}
                <td
                  className={cssExports.formValue}
                  colSpan={item.key === undefined ? 2 : undefined}
                >
                  {item.value}
                </td>
              </tr>
            ) : (
              <React.Fragment key={index} />
            )
          )}
        </tbody>
      </table>

      {!UtilsHelper.isEmpty(props.buttonText) && !props.hideButton && (
        <Grid container className={cssExports.buttonView}>
          <StyledButton size="sm" onClick={props.buttonOnClick}>
            {props.buttonText}
          </StyledButton>
        </Grid>
      )}
    </Grid>
  );
};

export default DetailsTable;
